import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class GlobalErrorMessageService {
    onNewErrorMessage = new EventEmitter<string>();
    onErrorConfirmed = new EventEmitter<void>();

    showErrorMessage (message: string) {
        this.onNewErrorMessage.emit(message);
    }

    confirmError () {
        this.onErrorConfirmed.emit();
    }
}
